import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-8057">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-8058">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-8059">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-8060">
            <ArrowLeft className="w-4 h-4" data-id="element-8061" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-8062">NOIZA</div>
          <div className="w-20" data-id="element-8063" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-8064">
        <div className="mb-12" data-id="element-8065">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-8066">
            <FileText className="w-6 h-6 text-white/80" data-id="element-8067" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-8068">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-8069">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-8070">
          <section data-id="element-8071">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8072">
              <span className="text-[#006847]" data-id="element-8073">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8074">
              <p data-id="element-8075">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-8076">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8077">
                <li data-id="element-8078">Haber leído íntegramente este documento</li>
                <li data-id="element-8079">Comprender su contenido en su totalidad</li>
                <li data-id="element-8080">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-8081">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-8082">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8083">
              <span className="text-[#006847]" data-id="element-8084">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8085">
              <p data-id="element-8086">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8087">
                <li data-id="element-8088">Software como servicio (SaaS)</li>
                <li data-id="element-8089">Marketplace digital gastronómico</li>
                <li data-id="element-8090">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-8091">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8092">
                <li data-id="element-8093">Mostrar su menú digital</li>
                <li data-id="element-8094">Recibir pedidos de clientes</li>
                <li data-id="element-8095">Gestionar su operación interna</li>
                <li data-id="element-8096">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-8097">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-8098">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8099">
              <span className="text-[#006847]" data-id="element-8100">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8101">
              <p data-id="element-8102">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8103">
                <li data-id="element-8104">No es proveedor de alimentos</li>
                <li data-id="element-8105">No participa en la preparación de productos</li>
                <li data-id="element-8106">No manipula alimentos en ningún momento</li>
                <li data-id="element-8107">No realiza entregas ni logística</li>
                <li data-id="element-8108">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-8109">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-8110">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-8111">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8112">
              <span className="text-[#006847]" data-id="element-8113">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-8114">
              <p data-id="element-8115">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-8116">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8117">
                <li data-id="element-8118">El restaurante es el único responsable de su operación</li>
                <li data-id="element-8119">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-8120">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-8121">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8122">
                <li data-id="element-8123">Precios</li>
                <li data-id="element-8124">Menú</li>
                <li data-id="element-8125">Horarios</li>
                <li data-id="element-8126">Métodos de pago</li>
                <li data-id="element-8127">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8128">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8129">
              <span className="text-[#006847]" data-id="element-8130">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-8131">
              <div data-id="element-8132">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8133">
                  5.1. Alcance general
                </h3>
                <p data-id="element-8134">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-8135">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8136">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-8137">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8138">
                  <li data-id="element-8139">Calidad de los alimentos</li>
                  <li data-id="element-8140">Estado, frescura o preparación</li>
                  <li data-id="element-8141">Ingredientes utilizados</li>
                  <li data-id="element-8142">Contaminación cruzada</li>
                  <li data-id="element-8143">Problemas de higiene o salubridad</li>
                  <li data-id="element-8144">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8145">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-8146">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8147">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-8148">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8149">
                  <li data-id="element-8150">Retrasos en la entrega</li>
                  <li data-id="element-8151">Pérdida de pedidos</li>
                  <li data-id="element-8152">Entregas incompletas</li>
                  <li data-id="element-8153">Errores en dirección</li>
                  <li data-id="element-8154">Conducta de repartidores</li>
                  <li data-id="element-8155">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-8156">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8157">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-8158">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-8159">
                  <li data-id="element-8160">Recepción de pagos</li>
                  <li data-id="element-8161">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-8162">Manejo de efectivo</li>
                  <li data-id="element-8163">Confirmación de pagos</li>
                  <li data-id="element-8164">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-8165">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8166">
                  <li data-id="element-8167">Pagos no recibidos</li>
                  <li data-id="element-8168">Comprobantes falsos</li>
                  <li data-id="element-8169">Errores en montos</li>
                  <li data-id="element-8170">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-8171">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8172">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-8173">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8174">
                  <li data-id="element-8175">Reclamos de clientes</li>
                  <li data-id="element-8176">Reembolsos</li>
                  <li data-id="element-8177">Cancelaciones</li>
                  <li data-id="element-8178">Disputas</li>
                  <li data-id="element-8179">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8180">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-8181">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8182">
              <span className="text-[#006847]" data-id="element-8183">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-8184">
              <p data-id="element-8185">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8186">
                <li data-id="element-8187">Responsable</li>
                <li data-id="element-8188">Legal</li>
                <li data-id="element-8189">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-8190">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8191">
                <li data-id="element-8192">Publicar información falsa</li>
                <li data-id="element-8193">Manipular precios de forma engañosa</li>
                <li data-id="element-8194">Simular disponibilidad inexistente</li>
                <li data-id="element-8195">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8196">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8197">
              <span className="text-[#006847]" data-id="element-8198">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-8199">
              <p data-id="element-8200">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8201">
                <li data-id="element-8202">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-8203">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-8204">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8205">
                <li data-id="element-8206">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-8207">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-8208">
                    <li data-id="element-8209">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-8210">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-8211">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8212">
              <span className="text-[#006847]" data-id="element-8213">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-8214">
              <p data-id="element-8215">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8216">
                <li data-id="element-8217">Menú digital</li>
                <li data-id="element-8218">Gestión de pedidos</li>
                <li data-id="element-8219">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-8220">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8221">
                  <p className="font-medium text-white mb-2" data-id="element-8222">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8223">
                    <li data-id="element-8224">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8225">
                  <p className="font-medium text-white mb-2" data-id="element-8226">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8227">
                    <li data-id="element-8228">Propiedad del software</li>
                    <li data-id="element-8229">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-8230">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-8231">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8232">
              <span className="text-[#006847]" data-id="element-8233">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8234">
              <p data-id="element-8235">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8236">
                <li data-id="element-8237">Disponibilidad continua</li>
                <li data-id="element-8238">Funcionamiento sin interrupciones</li>
                <li data-id="element-8239">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-8240">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8241">
                <li data-id="element-8242">Fallas técnicas</li>
                <li data-id="element-8243">Actualizaciones</li>
                <li data-id="element-8244">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-8245">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-8246">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8247">
              <span className="text-[#006847]" data-id="element-8248">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-8249">
              <p data-id="element-8250">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8251">
                <li data-id="element-8252">No está garantizada permanentemente</li>
                <li data-id="element-8253">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-8254">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8255">
                <li data-id="element-8256">Destacar o no restaurantes</li>
                <li data-id="element-8257">Modificar posiciones</li>
                <li data-id="element-8258">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8259">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8260">
              <span className="text-[#006847]" data-id="element-8261">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8262">
              <p data-id="element-8263">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8264">
                <li data-id="element-8265">Cumplir con los pagos acordados</li>
                <li data-id="element-8266">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8267">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8268">
                <li data-id="element-8269">Suspender el servicio</li>
                <li data-id="element-8270">Limitar funcionalidades</li>
                <li data-id="element-8271">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8272">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8273">
              <span className="text-[#006847]" data-id="element-8274">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8275">
              <p data-id="element-8276">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8277">
                <li data-id="element-8278">Incumplimiento de términos</li>
                <li data-id="element-8279">Uso indebido</li>
                <li data-id="element-8280">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8281">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8282">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8283">
              <span className="text-[#006847]" data-id="element-8284">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8285">
              <p data-id="element-8286">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8287">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8288">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8289">
              <span className="text-[#006847]" data-id="element-8290">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8291">
              <p data-id="element-8292">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8293">
                <li data-id="element-8294">Pérdidas económicas</li>
                <li data-id="element-8295">Daños indirectos</li>
                <li data-id="element-8296">Lucro cesante</li>
                <li data-id="element-8297">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8298">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8299">
              <span className="text-[#006847]" data-id="element-8300">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8301">
              <p data-id="element-8302">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8303">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8304">
              <span className="text-[#006847]" data-id="element-8305">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8306">
              <p className="font-medium" data-id="element-8307">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8308">
                <li data-id="element-8309">Ha leído este documento completo</li>
                <li data-id="element-8310">Comprende su alcance</li>
                <li data-id="element-8311">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}